// @flow
import React from 'react';

import { ICONS } from 'Components/utils/icon/icons';

import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { Tag, type TagProps } from 'Components/frameworks/tag/Tag.jsx';
import { Text } from 'Components/frameworks/text/Text.jsx';

import { themes } from './PostAnswer.themes';

export type PostAnswerProps = {
  author?: string,
  className?: string,
  date?: string,
  hasLabel?: boolean,
  id?: string,
  likesCount?: number,
  likesLabel?: string,
  tag?: TagProps,
  text: string,
  theme?: string,
};

export function PostAnswer(props: PostAnswerProps) {
  const {
    author,
    className,
    date,
    hasLabel,
    id,
    likesCount = 0,
    likesLabel,
    tag,
    theme = 'default',
    text,
  } = props;

  if (!text) return null;

  const {
    thAuthor,
    thBottom,
    thDate,
    thIcon,
    thIconSize,
    thLikes,
    thLikesLabel,
    thTag,
    thTextTheme,
  } = themes[theme];

  return (
    <article id={id} className={className}>
      <Tag className={thTag} {...tag} />
      <Text text={text} theme={thTextTheme} />
      {(!!author || !!date || !!likesCount) && (
        <div className={thBottom}>
          <div>
            {!!author && <span className={thAuthor}>{author}</span>}
            {!!author && !!date && ' - '}
            {!!date && <span className={thDate}>{date}</span>}
          </div>
          <div className={thLikes}>
            {hasLabel && !!likesLabel && <span className={thLikesLabel}>{likesLabel}</span>}
            <Icon className={thIcon} name={ICONS.HEART_FILLED} width={thIconSize} />
            {likesCount}
          </div>
        </div>
      )}
    </article>
  );
}
